import * as React from 'react';
import { Autocomplete, TextField, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles'
import { Box } from '@mui/material/node';

export const AppBarSearch = (props) => {
    const [searchFieldValue, setSearchFieldValue] = React.useState(false);

    const handleSearch = labelOptionValue => {
        if (!labelOptionValue) return;
        props.canvasRef.current.SelectItemOnCanvas(labelOptionValue.id);
        props.canvasRef.current.FitToSelected();
    };

    const theme = createTheme({
        components: {
            MuiAutocomplete: {
                styleOverrides: {
                    popupIndicator: {
                        color: "#ffffff",
                        '&:hover': {
                            color: "#ffffff",
                        }
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: "#ffffff",
                        '&:hover': {
                            color: "#ffffff",
                        },
                        "&.Mui-focused": {
                            color: "#ffffff",
                        },
                    },
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {

                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        "&.Mui-focused": {
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderWidth: "1px",
                                borderColor: "#ffffff",
                            },
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderRadius: 15,
                            borderColor: "#ffffff"
                        }
                    },
                    notchedOutline: {
                        borderColor: "#ffffff",
                        borderRadius: 15,
                    },
                }
            }
        }
    });

    return (
        <ThemeProvider theme={theme}>
            <Autocomplete
                disablePortal
                color="inherit"
                id="searchBar"
                onChange={(event, newValue) => {
                    handleSearch(newValue);
                }}
                options={props.elements}
                getOptionLabel={(option) => option.data.name}
                sx={{ width: 300 }}
                renderOption={(props, option) => (
                    // <li {...props} key={option.id}>
                    //     <LabelImportantIcon/>  {option.name}
                    // </li>
                    <Box
                        component="li"
                        sx={{ "& > span": { mr: 2, flexShrink: 0 } }}
                        {...props}
                        key={option.data.id}
                    >
                        {/* <LabelOutlinedIcon/> */}
                        {option.data.name}
                    </Box>
                )}
                renderInput={(params) => <TextField {...params} variant="outlined" size='small' label="Search" InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                        <>
                            {/* <InputAdornment position="start">
                          <LabelIcon/>
                        </InputAdornment> */}
                            {params.InputProps.startAdornment}
                        </>
                    )
                }} />}
            />
        </ThemeProvider>
    );
}